import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.repair-command',
    method: 'get',
    params,
  })
}

export const listAll = (params?: any) => {
  return axiosService({
    url: '/api.repair-command/all',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.request/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.repair-command/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.repair-command/${id}`,
    method: 'put',
    data,
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.repair-command/${id}/reject`,
    method: 'put',
    data,
  })
}

export const approve = (id: number, data: any) => {
  return axiosService({
    url: `/api.repair-command/${id}/approve`,
    method: 'put',
    data,
  })
}

export const apply = (id: number, data: any) => {
  return axiosService({
    url: `/api.repair-command/${id}/apply`,
    method: 'put',
    data,
  })
}

export const process = (id: number, data: any) => {
  return axiosService({
    url: `/api.repair-command/${id}/process`,
    method: 'put',
    data,
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.repair-command/${id}/remake`,
    method: 'put',
    data,
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.repair-command/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.repair-command',
    method: 'post',
    data,
  })
}
